module.exports = __webpack_public_path__ + "img/dlt_kind_1.svg.bak.14fdaecc.svg";